<div class="angola-map-root">

  <!-- TOOLBAR -->
  <div class="map-toolbar" *ngIf="showToolbar">
    <div class="vista-btns">
      <button class="vista-btn" [class.active]="vista === 'mapa'" (click)="switchVista('mapa')">
        <i class="fas fa-map"></i> Mapa
      </button>
      <button class="vista-btn" [class.active]="vista === 'tabela'" (click)="switchVista('tabela')">
        <i class="fas fa-grip"></i> Cards
      </button>
    </div>

    <div class="map-kpis" *ngIf="vista === 'mapa'">
      <span class="kpi-pill">
        <i class="fas fa-map-marker-alt"></i>
        <strong>{{ postos.length }}</strong>&nbsp;postos
      </span>
      <span class="kpi-pill kpi-green">
        <span class="kpi-dot green"></span>
        {{ postosAtivos }} activos
      </span>
      <span class="kpi-pill kpi-red" *ngIf="postosCriticos > 0">
        <span class="kpi-dot red"></span>
        {{ postosCriticos }} críticos
      </span>
    </div>

    <div class="map-legend" *ngIf="vista === 'mapa'">
      <span class="leg-item"><span class="leg-dot green"></span> Risco Baixo</span>
      <span class="leg-item"><span class="leg-dot yellow"></span> Risco Moderado</span>
      <span class="leg-item"><span class="leg-dot red"></span> Risco Alto/Crítico</span>
      <span class="leg-item"><span class="leg-dot grey"></span> Inactivo</span>
    </div>

    <button class="btn-criar" *ngIf="showCriarBtn" (click)="criarPosto.emit({})">
      <i class="fas fa-plus"></i> Criar Posto
    </button>
  </div>

  <!-- VISTA MAPA -->
  <div class="map-body" [style.display]="vista === 'mapa' ? 'block' : 'none'" [style.height]="height">
    <div id="postos-leaflet-map" class="leaflet-map-container"></div>

    <div class="map-no-coords" *ngIf="postosComCoords === 0 && postos.length > 0">
      <i class="fas fa-map-marker-slash"></i>
      <p>Nenhum posto tem coordenadas GPS registadas.</p>
    </div>
  </div>

  <!-- VISTA TABELA -->
  <div class="table-body" *ngIf="vista === 'tabela'">
    <ng-content select="[slot=tabela]"></ng-content>
  </div>

</div>
